import { PANACEA_URL } from '../constants.json';

export const myFlipdish = (appId = '', preventCache?: boolean) => {
  return `${PANACEA_URL}/${appId}${preventCache ? `?touch=${Date.now()}` : ''}`;
};
